import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, withDirectives as _withDirectives, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-9e8a6d22")

_pushScopeId("data-v-9e8a6d22")
const _hoisted_1 = { class: "edit-thumbnail" }
const _hoisted_2 = { class: "view" }
const _hoisted_3 = /*#__PURE__*/_createVNode("p", { class: "large-text" }, "以下の作業ファイルを削除しますか？", -1)
const _hoisted_4 = { class: "thumbnail" }
const _hoisted_5 = { class: "center" }
const _hoisted_6 = { class: "commands" }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "キャンセル", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", null, "削除", -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TemplateThumbnail = _resolveComponent("TemplateThumbnail")
  const _component_ThreeDotsMenu = _resolveComponent("ThreeDotsMenu")
  const _component_modal = _resolveComponent("modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode(_component_TemplateThumbnail, {
        class: "thumbnail",
        item: _ctx.template,
        editData: _ctx.editData
      }, null, 8, ["item", "editData"]),
      _createVNode(_component_ThreeDotsMenu, {
        class: "menu",
        items: _ctx.isNoTemplate ? _ctx.itemDelete : _ctx.items,
        title: _ctx.editData.title,
        isRight: _ctx.isRightMenu
      }, null, 8, ["items", "title", "isRight"])
    ]),
    _withDirectives(_createVNode("label", {
      class: "title",
      onDblclick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.startEdit && _ctx.startEdit(...args)))
    }, _toDisplayString(_ctx.editData.title), 545), [
      [_vShow, !_ctx.isEditTitle]
    ]),
    _withDirectives(_createVNode("input", {
      ref: "input",
      class: "title",
      type: "text",
      maxlength: _ctx.consts.maxEditTitleLength,
      value: _ctx.editData.title,
      onBlur: _cache[2] || (_cache[2] = ($event: any) => (_ctx.endEdit(false))),
      onKeydown: [
        _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.endEdit(false)), ["prevent"]), ["enter"])),
        _cache[4] || (_cache[4] = _withKeys(($event: any) => (_ctx.endEdit(true)), ["esc"]))
      ]
    }, null, 40, ["maxlength", "value"]), [
      [_vShow, _ctx.isEditTitle]
    ]),
    _createVNode(_component_modal, {
      class: "confirm",
      isShow: _ctx.isShowConfirm,
      "onUpdate:isShow": _cache[7] || (_cache[7] = ($event: any) => (_ctx.isShowConfirm = $event)),
      title: "作業ファイルの削除",
      isLeftTitle: true,
      onKeydown: _withKeys(_withModifiers(_ctx.deleteIt, ["prevent"]), ["enter"])
    }, {
      default: _withId(() => [
        _hoisted_3,
        _createVNode("div", _hoisted_4, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.twoBytwoOrder(_ctx.template.frames), (frame, i) => {
            return (_openBlock(), _createBlock("img", {
              key: frame.id,
              src: _ctx.toResourceUrl(frame.balloonOn),
              class: {
            lt: i == 0,
            rt: i == 1,
            lb: i == 2,
            rb: i == 3,
          }
            }, null, 10, ["src"]))
          }), 128))
        ]),
        _createVNode("p", _hoisted_5, _toDisplayString(_ctx.editData.title), 1),
        _createVNode("div", _hoisted_6, [
          _createVNode("button", {
            class: "primary-button modal-button",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.isShowConfirm = false))
          }, [
            _hoisted_7
          ]),
          _createVNode("button", {
            class: "danger-button modal-button",
            onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.deleteIt && _ctx.deleteIt(...args)))
          }, [
            _hoisted_8
          ])
        ])
      ]),
      _: 1
    }, 8, ["isShow", "onKeydown"])
  ]))
})